<div class="tcg-container" *transloco="let t;">
  <div class="tcg-header">
    <h1>{{t('kmonHunters.dash.pageTitle')}}</h1>
    <k-button buttonStyle="transparent" (click)="openCollection()" [label]="t('kmonHunters.dash.buttonAction')" size="sm"></k-button>
  </div>
  <div class="tcg-show-block">
    <div class="tcg-show-block-left">
      <div class="tcg-show-block-left-input">
        <div class="beta-banner">
          Currently, in closed beta in Italy. Stay tuned for mor ways to become a KMON Hunters
        </div>
        <img src="./assets/img/Icon/KMON-Hunters.png"/>
        <!--<p>{{t('kmonHunters.dash.inputTitle')}}</p>-->
        <input class="w-full mt-6 mb-4" type="text" placeholder="{{t('kmonHunters.dash.inputPlaceholder')}}" (focus)="flipBack()" [(ngModel)]="cardUuidCode" (keyup.enter)="redeemCard()" />
        <k-button buttonStyle="transparent" (click)="redeemCard()" [label]="t('kmonHunters.dash.buttonActionAdd')" size="sm"></k-button>
      </div>
      
    </div>
    <div class="tcg-show-block-right">
      <tcg-card [size]="'l'" [back]="bigCard.back" [id]="bigCard.id"></tcg-card>
      <img class="glowing" src="./assets/tcg/Glowinglight.png" />
    </div>
  </div>
  <div class="tcg-show-block-left-filters">
        <p>{{t('kmonHunters.dash.deckTitle')}}</p>
        <div class="tcg-show-block-left-filters-container">
          <div class="filter-button" *ngFor="let f of filters; let i = index" [ngClass]="{'selected':f.selected}" (click)="selectFilter(i)">
            <div class="filter-text">
              {{f.name}}
            </div>
            <div class="divider"></div>
            <div class="filter-count">
              {{f.collected}}/{{f.total}}
            </div>
          </div>
        </div>
      </div>
  <div class="tcg-list-block">
    <div class="tcg-list-block-card-wrapper" *ngFor="let c of cards | tcgCardFilter: pipeFilter">
      <tcg-card [size]="'md'" [id]="c.cardId" [count]="c.counter" (click)="highlightCard(c)"></tcg-card>
    </div>
    <div class="tcg-list-block-card-wrapper" *ngFor="let m of missingCards">
      <tcg-card [size]="'md'" [empty]="true"></tcg-card>
    </div>
  </div>
</div>
<div class="success-modal-overlay" (click)="showModal=false" *ngIf="showModal" >
  <div class="success-modal" *transloco="let t;">
    <img src="{{rewardImg}}" />
    <h1>{{t('kmonHunters.dash.congratsTitle')}}</h1>
    <p>{{t('kmonHunters.dash.congratsMSg')}}</p>
    <k-button buttonStyle="gradient" [label]="'Close'" (onClickAction)="showModal=false"></k-button>
  </div>
</div>
<div class="spin-the-weel-banner" [ngClass]="{'showSpinning': hasFreeSpin}" *transloco="let t;">
  <fa-icon [icon]="['fas', 'times']" (click)="hasFreeSpin=!hasFreeSpin"></fa-icon>
  <img src="./assets/img/Icon/clover.png" />
  <div class="spin-weel-text" (click)="gotoSpin()">
    <h1>{{t('kmonHunters.dash.spinTitle')}}</h1>
    <p>{{t('kmonHunters.dash.spingMsg')}}</p>
  </div>
</div>
